export function generateRandomToken(length) {
  const chars = `qwertyuiopasdfghjkl;nmzxcvb,./'-0987654321`;
  let result = "";
  const charsLength = chars.length;
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * charsLength));
  }
  return result;
}

export function capitalizeWords(string) {
  if (!string) return "";
  return string
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function safeParseJSON(data) {
  if (!data) return {};
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error("Error parseando JSON del backend:", error);
      return {};
    }
  }
  return data;
}

export const buildJsonObject = (nodes) => {
  const obj = {};

  nodes.forEach((node) => {
    if (!node.key) return;

    if (node.type === "object") {
      obj[node.key] = buildJsonObject(node.children || []);
    } else if (node.type === "array") {
      obj[node.key] = (node.children || []).map((child) => {
        if (child.type === "object") {
          return buildJsonObject(child.children || []);
        }
        return child.value;
      });
    } else if (node.type === "number") {
      obj[node.key] = Number(node.value);
    } else if (node.type === "boolean") {
      obj[node.key] = node.value === "true" || node.value === true;
    } else {
      obj[node.key] = node.value;
    }
  });

  return obj;
};

export const jsonToNodes = (json) => {
  return Object.entries(json).map(([key, value]) => {
    if (Array.isArray(value)) {
      return {
        id: Date.now().toString() + Math.random(),
        key: key,
        type: "array",
        value: "",
        children: value.map((item, index) => ({
          id: Date.now().toString() + Math.random(),
          key: `Item ${index + 1}`,
          type: typeof item === "object" && item !== null ? "object" : "string",
          value: typeof item !== "object" ? item : "",
          children:
            typeof item === "object" && item !== null ? jsonToNodes(item) : [],
        })),
      };
    } else if (typeof value === "object" && value !== null) {
      return {
        id: Date.now().toString() + Math.random(),
        key: key,
        type: "object",
        value: "",
        children: jsonToNodes(value),
      };
    } else {
      return {
        id: Date.now().toString() + Math.random(),
        key: key,
        type: typeof value,
        value: value,
        children: [],
      };
    }
  });
};

export function getDefaultWebhookAttrs() {
  return [
    "{{order_id}}",
    "{{reference_id}}",
    "{{status}}",
    "{{substatus}}",
    "{{status_timestamps}}",
    "{{comments}}",
    "{{recipient_name}}",
    "{{recipient_phone}}",
    "{{recipient_email}}",
    "{{address}}",
    "{{street_number}}",
    "{{commune}}",
    "{{region}}",
    "{{url_images}}",
    "{{current_date}}",
  ];
}

export function getAltanetTemplate() {
  return {
    Empresa: "{{seller_social_reason}}",
    Bodega: "SANTA_ELENA",
    Usuario: "NinjaHub",
    Entidad: {
      Empresa: "{{seller_social_reason}}",
      Entidad: "Qslogisticsprueba01",
      Nombre: "{{recipient_name}}",
      Tipo_relacion_comercial: "CL",
      Rut: 0,
      Dv: "",
      Giro: "",
      Direccion: "{{address}} {{street_number}}",
      Comuna: "{{commune}}",
      Telefono: "{{recipient_phone}}",
      Estado: "AC",
      Email: "{{recipient_email}}",
    },
    Movimiento_solicitado: {
      Empresa: "{{seller_social_reason}}",
      Bodega: "SANTA_ELENA",
      Documento_solicitado: "OD",
      Tipo_movimiento: "DEC",
      Fecha_movimiento: "{{current_date}}",
      Fecha_programada: "{{scheduled_date}}",
      Responsable: "aduran",
      Entidad: "Qslogisticsprueba01",
      Documento_respaldo: "PR",
      Numero_documento_respaldo: "{{reference_id}}",
      IDENTIFICADOR_ERP: "{{order_id}}",
      Notas: "Sitio 27",
      Estado: "AU",
    }
  };
}

/*
 * `dateToDatabase` lived here and is gone. It took a Date and called
 * `toISOString()` on it, so it threw on the strings the filters actually hold —
 * which is how the label download ended up failing before it made a request —
 * and its UTC day was wrong for anything picked after 21:00 in Chile.
 *
 * Use `toLocalDateString` from `utils/dates` when a Date has to become a
 * `YYYY-MM-DD`; the filters are already stored in that shape.
 */

export const getMode = (user) => {
  if (user?.user_type?.includes("admin")) {
    return "admin";
  } else if (user?.user_type?.includes("operator")) {
    return "operator";
  } else if (user?.user_type?.includes("seller")) {
    return "seller";
  }
  return null;
};
